<template>
  <div class="app-container tier-add">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button size="medium" @click="cancel">取消</el-button>
        <el-button size="medium" type="primary" @click="onSubmit('tierInfo')">保存</el-button>
      </div>

      <el-form class="tier-form" ref="tierInfo" :model="tierInfo" label-width="140px" size="medium" :rules="rules">
        <el-row gutter="20">

          <el-form-item v-if="!isEdit" label="等级" prop="tierId" >
            <el-input-number v-model="tierInfo.tierId" controls-position="right" :min="1" :max="100"></el-input-number>
          </el-form-item>

          <el-form-item label="个人号等级称号" prop="personalName">
            <el-input class="tier-form-input" v-model="tierInfo.personalName" placeholder="请输入个人号等级称号"></el-input>
          </el-form-item>

          <el-form-item label="个人号等级头像效果">
            <el-row>
              <el-col :span="3" :push="1">
                <div class="image-preview">
                  <img class="anonymous-image" :src="anonymousImage">
                  <img class="avatar-icon" v-if="tierInfo.personalIcon" :src="tierInfo.personalIcon">
                  <img class="avatar-bgi" v-if="tierInfo.personalBgi" :src="tierInfo.personalBgi">
                </div>
              </el-col>
              <el-row>
                <el-col :span="12" :push="1">
                  <el-button size="mini" type="primary" @click="editPersonalIcon">{{tierInfo.personalIcon ? '编辑头像角标' : '添加头像角标'}}</el-button>
                  <el-button size="mini" type="danger" v-show="tierInfo.personalIcon" @click="clearPersonalIcon">删除头像角标</el-button>
                </el-col>
                <el-col :span="12" :push="1">
                  <el-button size="mini" type="primary" @click="editPersonalBgi">{{tierInfo.personalBgi ? '编辑头像背景框' : '添加头像背景框'}}</el-button>
                  <el-button size="mini" type="danger" v-show="tierInfo.personalBgi" @click="clearPersonalBgi">删除头像背景框</el-button>
                </el-col>
              </el-row>
            </el-row>
          </el-form-item>

          <el-form-item label="官方号等级称号" prop="officialName">
            <el-input class="tier-form-input" v-model="tierInfo.officialName" placeholder="请输入官方号等级称号"></el-input>
          </el-form-item>

          <el-form-item label="官方号等级头像效果">
            <el-row>
              <el-col :span="3" :push="1">
                <div class="image-preview">
                  <img class="anonymous-image" :src="anonymousImage">
                  <img class="avatar-icon" v-if="tierInfo.officialIcon" :src="tierInfo.officialIcon">
                  <img class="avatar-bgi" v-if="tierInfo.officialBgi" :src="tierInfo.officialBgi">
                </div>
              </el-col>
              <el-row>
                <el-col :span="12" :push="1">
                  <el-button size="mini" type="primary" @click="editOfficialIcon">{{tierInfo.officialIcon ? '编辑头像角标' : '添加头像角标'}}</el-button>
                  <el-button size="mini" type="danger" v-show="tierInfo.officialIcon" @click="clearOfficialIcon">删除头像角标</el-button>
                </el-col>
                <el-col :span="12" :push="1">
                  <el-button size="mini" type="primary" @click="editOfficialBgi">{{tierInfo.officialBgi ? '编辑头像背景框' : '添加头像背景框'}}</el-button>
                  <el-button size="mini" type="danger" v-show="tierInfo.officialBgi" @click="clearOfficialBgi">删除头像背景框</el-button>
                </el-col>
              </el-row>
            </el-row>
          </el-form-item>
        </el-row>
      </el-form>
    </basic-container>

    <material-selector v-if="showMaterialSelector"
                  type="picture"
                  :visible="showMaterialSelector"
                  :limit="1"
                  :accept="['jpg', 'jpeg', 'png', 'gif']"
                  @close="handleMaterialSelectorClose"
                  @confirm-select="handleConfirmSelect"></material-selector>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import anonymousImage from '@/static/images/member/anonymous.svg'
  import MaterialSelector from '@/components/material-selector/MaterialSelector.vue'
  import { fetchAccountTierByTierId, addAccountTier, updateAccountTier } from '@/api/admin/tier'

  export default {
    components: {
      MaterialSelector
    },
    data () {
      return {
        tierId: undefined,
        tierInfo: {
          tierId: undefined,
          personalName: '',
          personalIcon: '',
          personalBgi: '',
          officialName: '',
          officialIcon: '',
          officialBgi: '',
        },
        loading: false,
        isEdit: false,
        currentEdit: undefined,
        tierInfoAttributeEnum: {
          personalIcon: 1,
          personalBgi: 2,
          officialIcon: 3,
          officialBgi: 4
        },
        showMaterialSelector: false,
        anonymousImage,
        rules: {
          tierId: [
            { type: 'number', required: true, message: '请输入等级', trigger: 'change' },
          ],
          personalName: [
            { type: 'string', required: true, message: '请输入个人号等级称号', trigger: 'blur' },
            { max: 20, message: '不超过20个字符', trigger: 'blur' }
          ],
          officialName: [
            { type: 'string', required: true, message: '请输入官方号等级称号', trigger: 'blur' },
            { max: 20, message: '不超过20个字符', trigger: 'blur' }
          ],
        }
      }
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    mounted () {
      this.isEdit = this.$route.path.includes('edit')
      this.tierId = this.$route.params.tierId || undefined
      if(this.tierId) {
        this.getAccountTierByTierId(this.tierId)
      }
    },
    methods: {
      cancel () {
        this.$router.$avueRouter.closeTag()
        this.$router.go(-1)
      },
      onSubmit (formName) {
        const params = this.tierInfo;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.isEdit) {
              this.handleEditAccountTier(params)
            } else {
              this.handleAddAccountTier(params)
            }
          } else {
            this.$message({
              message: '请通过验证',
              type: 'error'
            })
            return false;
          }
        });
      },
      getAccountTierByTierId(tierId) {
        fetchAccountTierByTierId(tierId).then(response => {
          this.tierInfo.tierId = response.data.data.tierId
          this.tierInfo.personalName = response.data.data.personalName
          this.tierInfo.personalIcon = response.data.data.personalIcon || ''
          this.tierInfo.personalBgi = response.data.data.personalBgi || ''
          this.tierInfo.officialName = response.data.data.officialName
          this.tierInfo.officialIcon = response.data.data.officialIcon || ''
          this.tierInfo.officialBgi = response.data.data.officialBgi || ''
        });
      },
      handleAddAccountTier(param) {
        addAccountTier(param).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '创建成功',
              type: 'success'
            })
            this.$router.$avueRouter.closeTag()
            this.$router.push({
              path: `/member/tier`,
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      },
      handleEditAccountTier(param) {
        updateAccountTier(param).then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '编辑成功',
              type: 'success'
            })
            this.$router.$avueRouter.closeTag()
            this.$router.push({
              path: `/member/tier`,
            })
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      },
      editPersonalIcon() {
        this.showMaterialSelector = true
        this.currentEdit = this.tierInfoAttributeEnum.personalIcon
      },
      clearPersonalIcon() {
        this.tierInfo.personalIcon = ''
      },
      editPersonalBgi() {
        this.showMaterialSelector = true
        this.currentEdit = this.tierInfoAttributeEnum.personalBgi
      },
      clearPersonalBgi() {
        this.tierInfo.personalBgi = ''
      },
      
      editOfficialIcon() {
        this.showMaterialSelector = true
        this.currentEdit = this.tierInfoAttributeEnum.officialIcon
      },
      clearOfficialIcon() {
        this.tierInfo.officialIcon = ''
      },
      editOfficialBgi() {
        this.showMaterialSelector = true
        this.currentEdit = this.tierInfoAttributeEnum.officialBgi
      },
      clearOfficialBgi() {
        this.tierInfo.officialBgi = ''
      },
      handleConfirmSelect (materialList) {
        this.showMaterialSelector = false;
        let selectedMaterialUrl = materialList[0].contentUrl
        switch (this.currentEdit) {
          case this.tierInfoAttributeEnum.personalIcon:
            this.tierInfo.personalIcon = selectedMaterialUrl
            break;
          case this.tierInfoAttributeEnum.personalBgi:
            this.tierInfo.personalBgi = selectedMaterialUrl
            break;
          case this.tierInfoAttributeEnum.officialIcon:
            this.tierInfo.officialIcon = selectedMaterialUrl
            break;
          case this.tierInfoAttributeEnum.officialBgi:
            this.tierInfo.officialBgi = selectedMaterialUrl
            break;
        }
      },
      handleMaterialSelectorClose () {
        this.showMaterialSelector = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
.tier-add {
  .operation {
    text-align: right
  }
}
.tier-form {
  width: 100%;
  &-input {
    width: 50%;
  }
}
.image-preview {
  position:relative;
  margin-bottom: 15px;
  .anonymous-image{
    width: 70px;
    height: 70px;
    top: 3px;
    border-radius: 6px;
    margin-right: 8px;
    float: left;
    object-fit: cover;
  }
  .avatar-icon {
    position:absolute;
    width: 20px;
    height: 20px;
    top: 50px;
    left: 45px;
    z-index: 2;
  }
  .avatar-bgi {
    position:absolute;
    width: 85px;
    height: 85px;
    top: -13px;
    left: -8px;
    z-index: 1;
  }
}
</style>